import {AfterContentInit, Component, Input} from '@angular/core';

/**
 * Component for the type badge
 * @class ContentTypeBadgeComponent
 * @implements {AfterContentInit}
 */
@Component({
  selector: 'advtech-content-type-badge',
  templateUrl: './content-type-badge.component.html',
})
export class ContentTypeBadgeComponent implements AfterContentInit {
  /**
   * static variable because the value was used a bunch
   * @type {string}
   */
  static typeIcon = 'type-icon';

  /**
   * static variable because the value was used a bunch
   * @type {string}
   */
  static ctText = 'ct-text';

  /**
   * static variable because the value was used a bunch
   * @type {string}
   */
  static ctMixed = 'ct-mixed';

  /**
   * static variable because the value was used a bunch
   * @type {string}
   */
  static ctMedia = 'ct-media';

  /**
   * object holding the bade properties
   * @type {{article: {class: string; text: string}; blog: {class: string; text: string}; collection: {class: string; text: string}; feature: {class: string; text: string}; gallery: {class: string; text: string}; image: {class: string; text: string}; media_post: {class: string; text: string}; newsletter: {class: string; text: string}; playlist: {class: string; text: string}; poll: {class: string; text: string}; review: {class: string; text: string}; video: {class: string; text: string}}}
   */
  static contentTypes: any = {
    article: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-article ${ContentTypeBadgeComponent.ctText}`,
      text: 'Ar',
    },
    blog: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-blog ${ContentTypeBadgeComponent.ctMixed}`,
      text: 'Bl',
    },
    collection: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-collection ${ContentTypeBadgeComponent.ctMixed}`,
      text: 'Co',
    },
    feature: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-feature ${ContentTypeBadgeComponent.ctMixed}`,
      text: 'Fe',
    },
    gallery: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-gallery ${ContentTypeBadgeComponent.ctMedia}`,
      text: 'Ga',
    },
    image: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-image ${ContentTypeBadgeComponent.ctMedia}`,
      text: 'Im',
    },
    media_post: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-media-post ${ContentTypeBadgeComponent.ctMedia}`,
      text: 'Mp',
    },
    newsletter: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-newsletter ${ContentTypeBadgeComponent.ctMixed}`,
      text: 'Ns',
    },
    playlist: {
      class: `${ContentTypeBadgeComponent.typeIcon} ct-playlist ${ContentTypeBadgeComponent.ctMedia}`,
      text: 'Pl',
    },
    poll: {class: `${ContentTypeBadgeComponent.typeIcon} ct-poll ${ContentTypeBadgeComponent.ctMedia}`, text: 'Po'},
    review: {class: `${ContentTypeBadgeComponent.typeIcon} ct-review ${ContentTypeBadgeComponent.ctText}`, text: 'Rv'},
    video: {class: `${ContentTypeBadgeComponent.typeIcon} ct-video ${ContentTypeBadgeComponent.ctMedia}`, text: 'Vi'},
  };

  /**
   * the badge class
   * @type {string}
   */
  badgeClass: string = '';

  /**
   * the badge text
   * @type {string}
   */
  badgeText: string = '';

  /**
   * attribute to tell the scss that were doing a circle button (FAB lists)
   */
  @Input()
  circle: boolean;

  /**
   * attribute to pass in the content type
   */
  @Input()
  contentType: string;

  /** @inheritdoc */
  ngAfterContentInit() {
    const contentType = ContentTypeBadgeComponent.contentTypes[this.contentType];
    if (contentType) {
      this.badgeClass = contentType.class;
      this.badgeText = contentType.text;
      if (this.circle) {
        this.badgeClass += ' circle';
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-type-badge/content-type-badge.component.ts